import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./StonesSelector.module.css";

const stoneTypes = [
  {
    id: "local",
    title: "Local Natural Stones",
    description: "Authentic stones sourced locally from the finest quarries, perfect for traditional architecture.",
    image: "/assets/stones/local-stone-preview.jpg",
    route: "/stones/local"
  },
  {
    id: "imported",
    title: "Imported Natural Stones",
    description: "Premium stones imported from around the world, bringing exotic elegance to your projects.",
    image: "/assets/stones/imported-stone-preview.jpg",
    route: "/stones/imported"
  }
];

const StonesSelector = () => {
  const navigate = useNavigate();
  
  // Function to navigate using query parameters
  const navigateWithQueryParam = (route) => {
    navigate(`/?page=${route}`);
  };
  
  return (
    <section className={styles.stonesSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Our Premium Stone Collection</h2>
          <div className={styles.divider}></div>
          <p className={styles.subtitle}>
            Discover our exclusive selection of both local and imported natural stones, 
            carefully curated to bring timeless beauty to your construction projects.
          </p>
        </div>
        
        <div className={styles.stoneCards}>
          {stoneTypes.map((stone) => (
            <div key={stone.id} className={styles.stoneCard}>
              <div 
                className={styles.stoneImage}
                style={{ backgroundImage: `url(${stone.image})` }}
              >
                <div className={styles.overlay}></div>
              </div>
              <div className={styles.stoneContent}>
                <h3 className={styles.stoneTitle}>{stone.title}</h3>
                <div className={styles.stoneContentDivider}></div>
                <p className={styles.stoneDescription}>{stone.description}</p>
                <button 
                  className={styles.stoneButton}
                  onClick={() => navigateWithQueryParam(stone.route)}
                >
                  Explore Collection
                </button>
              </div>
              <div className={styles.cornerDecoration1}></div>
              <div className={styles.cornerDecoration2}></div>
            </div>
          ))}
        </div>
        
        <div className={styles.discoverMore}>
          <button 
            className={styles.discoverButton}
            onClick={() => navigateWithQueryParam("/stones")}
          >
            View All Collections
            <span className={styles.arrowIcon}>→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default StonesSelector;